const play = (e) => {
  const playButton = e.currentTarget;
  const video = playButton.closest(".media")?.querySelector(".media__video");

  if (!video) return;

  if (video.paused) {
    playButton.style.opacity = 0;
    video.play();
  } else {
    playButton.style.opacity = 1;
    video.pause();
  }
};
